var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:this.class,attrs:{"href":this.to,"target":this.target}},[_vm._v(_vm._s(this.name))])}
var staticRenderFns = []

export { render, staticRenderFns }